document.addEventListener('DOMContentLoaded', function () {
    const printPDF = document.getElementById("printPDF");
    const printPDF_toolbar = document.getElementById("printPDF_toolbar");
    const copyUrl = document.getElementsByClassName("copyUrl_clipboard2");
    const copyQuelle = document.getElementsByClassName("copyQuelle_clipboard");

    for (i = 0; i < copyUrl.length; i++) {
        if (copyUrl[i] !== null) {
            copyUrl[i].addEventListener('click', function () {
                navigator.clipboard.writeText(window.location.href);
            });
        }
    }

    const artikeldetail = document.querySelector(`[id^="artikel_detail_"]`);

    const urlParams = new URLSearchParams(window.location.search);
    const fromParam = urlParams.get('from');

    for (i = 0; i < copyQuelle.length; i++) {
        if (copyQuelle[i] !== null) {
            copyQuelle[i].addEventListener('click', function () {
                let quelle;
                if (artikeldetail.getAttribute("data-heft-issue").includes(fromParam)) {
                    if (document.getElementById("quellenverweis_heft") !== null) {
                        quelle = document.getElementById("quellenverweis_heft").innerText;
                    } else {
                        quelle = document.getElementById("quellenverweis").innerText;
                    }
                } else {
                    quelle = document.getElementById("quellenverweis").innerText;
                }
                navigator.clipboard.writeText(quelle);
            });
        }
    }



    if (printPDF !== null || printPDF_toolbar !== null) {
        printPDF.addEventListener('click', function () {
            let url = document.getElementById("pdf").getAttribute("href");
            let w = window.open(url);
            w.print();
            w.close();
        });
    }
});
